import { render } from "./content-entry-form.vue?vue&type=template&id=701f31a8&scoped=true"
import script from "./content-entry-form.vue?vue&type=script&lang=js"
export * from "./content-entry-form.vue?vue&type=script&lang=js"

import "./content-entry-form.vue?vue&type=style&index=0&id=701f31a8&scoped=true&lang=css"

import exportComponent from "/media/dolar/office/office_project/barmm-admin-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-701f31a8"]])

export default __exports__